<section class="sidebar">
  <div class="py-2">
    <div class="row row_div">
      <div class="position-sticky ">
        <div class="row align-items-center">
          <div class="col-5 d-none">
            <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarTogglerDemo01"
              aria-controls="navbarTogglerDemo01" aria-expanded="false" aria-label="Toggle navigation"
              (click)="showdropdown()">
              <span class="navbar-toggler-icon"></span>
            </button>
          </div>
          <div class="col-7 d-none">
            <img src="assets/images/New_logo.png" height="45px"/>
          </div>
        </div>
        <div class="logo pt-2 pb-4" [style]="{ 'padding-left': isOpen? '16px': '2px' }">
          <img [src]="isOpen? 'assets/images/New_logo.png': 'assets/images/sg_logo.svg'" height="86px" width="78%" />
        </div>
      </div>
    </div>
  </div>
  <div *ngIf="isShow" class="nav-height nav-width">
    <div *ngFor="let item of navigationList; let i = index;">
      <div class="non-accordion" *ngIf="(item.type == 1)|| (item.type == 2 && !isOpen)" [routerLink]="[item.routerLink]"
        routerLinkActive="router-link-active" (click)="singleLinkClicked(item)">
        <svg-icon [src]="item.svg"></svg-icon>
        <span *ngIf="isOpen">{{item.heading}}</span>
      </div>
      <div class="accordion-container" *ngIf="item.type == 2 && isOpen">
        <mat-accordion [multi]="false">
          <mat-expansion-panel [(expanded)]="item.isOpened"
            [ngClass]="{'accordionActive': item.isOpened}">
            <mat-expansion-panel-header (click)="closePanel(item)">
              <mat-panel-description>
                <div class="text">
                  <span class="fixHeight">
                  <svg-icon [src]="item.svg" ></svg-icon></span>
                  {{isOpen?item.heading:''}}
                </div>
              </mat-panel-description>

            </mat-expansion-panel-header>
            <ul>
              <li *ngFor="let subitem of item.subheading" [routerLink]="subitem.routerLink"
                routerLinkActive="router-link-active">
                <div class="text"> {{isOpen?subitem.heading:''}} </div>
                
                <span *ngIf="subitem.heading.includes('SG Feed') && count>0" [ngClass]="count > 9 ? 'messageNotification' : 'messageNotificationheadCount'">
                  {{count > 9 ? '9+' :count }}
                </span> 
              </li>
            </ul>
          </mat-expansion-panel>
        </mat-accordion>
      </div>
    </div>
  </div>
</section>